<template>
    <div style="padding-top: 80px;">
        <a-empty :description="desc"/>
    </div>
</template>

<script>
    export default {
        name: "Developing",
        props: {
            desc: {
                type: String,
                default: "敬请期待 ..."
            }
        }
    }
</script>

<style scoped>

</style>
